import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { startVersionWatch, type VersionWatchOptions } from "../version";

export type VersionWatchConfig = Omit<VersionWatchOptions, "onNewVersion"> & {
  /** Reloads the page (location.reload); replaceable in tests. */
  reload?: () => void;
};

/**
 * "New version available": an open tab keeps running the old program after a deploy until it is reloaded.
 * The bar never reloads by itself (the user may be typing), the button does.
 */
export function NewVersionBar({ config }: { config: VersionWatchConfig | null }) {
  const { t } = useTranslation();
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    if (!config) return;
    return startVersionWatch({ ...config, onNewVersion: () => setAvailable(true) });
  }, [config]);
  if (!available || !config) return null;
  const reload = config.reload ?? (() => globalThis.location.reload());
  return (
    <div className="new-version" role="status">
      <p>
        <strong>{t("update.available")}</strong> <span>{t("update.saveFirst")}</span>
      </p>
      <button type="button" className="primary" onClick={() => reload()}>
        {t("update.reload")}
      </button>
    </div>
  );
}
